<div class="title-bar not-printable not-printable">
    <h3>
        <ng-container *ngIf="isAcquisition">Annahme</ng-container>
        <ng-container *ngIf="!isAcquisition">Vergabe</ng-container>
    </h3>
</div>

<div class="container-fluid main-card-wrapper not-printable">
    <div class="row">
        <div class="col-md-12">
            <div class="card" #card>
                <div class="card-header">
                    <h4 class="card-title">
                        <ng-container *ngIf="isAcquisition">Einfach- und Mehrfachannahme</ng-container>
                        <ng-container *ngIf="!isAcquisition">Einfach- und Mehrfachvergabe</ng-container>
                    </h4>
                </div>

                <div class="card-body">
                    <form class="form"
                          [formGroup]="acquisitionGiveAwayForm"
                          [ngClass]="{ 'displayErroneousInputs': displayErroneousInputs }">
                        <div class="row">
                            <div class="col-md-3">
                                <mat-form-field appearance="fill">
                                    <mat-label>Aktionstyp wählen...</mat-label>
                                    <mat-select #actionTypeSelect
                                                formControlName="actionType"
                                                (selectionChange)="actionTypeChanged()">
                                        <mat-option *ngFor="let action of actionTypes"
                                                    [value]="action.value"
                                                    [attr.symbol]="TupleHelper.getValue(action.meta, 'symbol')">
                                            {{action.viewValue}}
                                            <div class="animal-type fas"
                                                 [style]="{'background-color': TupleHelper.getValue(action.meta, 'color')}"
                                                 [ngClass]="TupleHelper.getValue(action.meta, 'symbol')"></div>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-3">
                                <mat-form-field class="mat-datetime-picker">
                                    <input matInput
                                           (click)="dateTimePicker.open()"
                                           [ngxMatDatetimePicker]="dateTimePicker"
                                           placeholder="Datum"
                                           formControlName="date"
                                           [min]="dateTimeConfig.minDate"
                                           [max]="dateTimeConfig.maxDate">
                                    <mat-datepicker-toggle matSuffix
                                                           [for]="dateTimePicker"></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker #dateTimePicker
                                                             [stepHour]="dateTimeConfig.stepHour"
                                                             [stepMinute]="dateTimeConfig.stepMinute">
                                    </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="mat-form-field-appearance-fill">
                                    <mat-select placeholder="Laufnummer"
                                                formControlName="animalId"
                                                (closed)="selectAnimalsCtrl.reset()"
                                                (ngModelChange)="addAnimalToTable($event)"
                                                [multiple]="true">
                                        <mat-option>
                                            <ngx-mat-select-search
                                                    [formControl]="selectAnimalsCtrl.multiFilterCtrl">
                                            </ngx-mat-select-search>
                                            <mat-progress-spinner
                                                    *ngIf="loadAnimals"
                                                    diameter="20"
                                                    class="animal-search-indicator"
                                                    color="accent"
                                                    mode="indeterminate">
                                            </mat-progress-spinner>
                                        </mat-option>
                                        <mat-option *ngIf="isAcquisition">
                                            <a class="add-new" (click)="openDialog(simpleDialogType.NEW_ANIMAL)"
                                               style="font-weight: 600">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div>Neues Tier erstellen...</div>
                                                    <div>
                                                        <i class="add-btn fas fa-plus d-flex justify-content-center align-items-center"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </mat-option>
                                        <mat-option *ngFor="let animal of selectAnimalsCtrl.filteredOptions | async"
                                                    (onSelectionChange)="animalSelected($event)"
                                                    [value]="animal">
                                            {{animal.id}} &mdash; {{animal.species.name}} &mdash; {{animal.race.name}}
                                            &mdash; {{animal.name}}
                                            <div class="controls animal-controls d-flex align-items-center">
                                                <a (click)="openEditDialog(animal)"
                                                   class="fas fa-edit icon prevent-opening"
                                                   matTooltip="Tierdaten bearbeiten"
                                                   matTooltipPosition="right"></a>
                                            </div>
                                        </mat-option>
                                        <mat-option *ngIf="selectAnimalsCtrl.values !== null &&
                                        selectAnimalsCtrl.values.length === 0">
                                            Keine Ergebnisse gefunden.
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-11">
                                <mat-form-field class="select-search">
                                    <mat-select placeholder="{{personSelectOneLabel}}"
                                                formControlName="person"
                                                (ngModelChange)="personSelectChange($event)"
                                                [compareWith]="comparePerson"
                                                #personSelect>
                                        <mat-option [classList]="'mat-option hidden-checkbox'">
                                            <a class="add-new" (click)="openDialog(simpleDialogType.NEW_PERSON, true)"
                                               style="font-weight: 600">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div>Neue Person erstellen...</div>
                                                    <div>
                                                        <i class="add-btn fas fa-plus d-flex justify-content-center align-items-center"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </mat-option>
                                        <mat-option *ngFor="let element of personSelectSearch.filteredElements | async"
                                                    [value]="element">
                                            {{element.viewValue}}
                                            <i class="fas fa-mask ml-1"
                                               [matTooltip]="'Bemerkung: ' + personRemark(element.meta)"
                                               matTooltipPosition="right"
                                               matTooltipClass="tooltip-popup"
                                               *ngIf="personRemark(element.meta) !== ''"></i>
                                            <div class="controls person-controls d-flex align-items-center">
                                                <a class="fas fa-edit icon"
                                                   (click)="openDialog(simpleDialogType.EDIT_PERSON, true, element)"
                                                   matTooltip="Person bearbeiten"
                                                   matTooltipPosition="right"
                                                   matTooltipClass="tooltip-popup"></a>
                                                <a class="fas fa-dog icon"
                                                   (click)="openDialog(SHOW_ASSOCIATED_ANIMALS_DIALOG, true, element)"
                                                   matTooltip="Alle tierbezogenen Transaktionen"
                                                   matTooltipPosition="right"
                                                   matTooltipClass="tooltip-popup"></a>
                                            </div>
                                        </mat-option>
                                        <mat-option *ngIf="personSelectSearch.values !== undefined &&
                                        personSelectSearch.values.length === 0">
                                            Keine Ergebnisse gefunden.
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-1 pl-0">
                                <a (click)="openDialog(simpleDialogType.SEARCH_PERSON)"
                                   class="fas fa-search icon"
                                   style="margin-top: 33px"
                                   matTooltip="Person suchen"
                                   matTooltipPosition="right"
                                   matTooltipClass="tooltip-popup"></a>
                            </div>

                            <div class="col-md-5 mt-3"
                                 *ngIf="selected === 'annahme-pensionstier' || selected === 'rueckgabe-pensionstier'">
                                <label>{{isAcquisition ? 'Überbringer' : 'Abholer'}} ist auch Besitzer?</label>
                                <mat-radio-group formControlName="bringerReceiverAreSame"
                                                 aria-label="Receiver and bringer are the same?"
                                                 (change)="toggleOwnerActive($event)"
                                                 name="bringerReceiverAreSame">
                                    <mat-radio-button value="yes" [checked]="true">Ja</mat-radio-button>
                                    <mat-radio-button value="no">Nein</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row"
                             [hidden]="(selected !== 'annahme-pensionstier' && selected !== 'rueckgabe-pensionstier') ||
                             acquisitionGiveAwayForm.controls.bringerReceiverAreSame.value !== 'no'">
                            <div class="col-md-11">
                                <mat-form-field class="select-search">
                                    <mat-select formControlName="owner"
                                                placeholder="Besitzer"
                                                (ngModelChange)="personSelectChange($event)"
                                                [compareWith]="comparePerson"
                                                #ownerSelect>
                                        <mat-option [classList]="'mat-option hidden-checkbox'">
                                            <a class="add-new" (click)="openDialog(simpleDialogType.NEW_PERSON, false)"
                                               style="font-weight: 600">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div>Neue Person erstellen...</div>
                                                    <div>
                                                        <i class="add-btn fas fa-plus d-flex justify-content-center align-items-center"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </mat-option>
                                        <mat-option *ngFor="let element of ownerSelectSearch.filteredElements | async"
                                                    [value]="element">
                                            {{element.viewValue}}
                                            <i class="fas fa-mask ml-1"
                                               [matTooltip]="'Bemerkung: ' + personRemark(element.meta)"
                                               matTooltipPosition="right"
                                               matTooltipClass="tooltip-popup"
                                               *ngIf="personRemark(element.meta) !== ''"></i>
                                            <div class="controls person-controls d-flex align-items-center">
                                                <a class="fas fa-edit icon"
                                                   (click)="openDialog(simpleDialogType.EDIT_PERSON, false, element)"
                                                   matTooltip="Person bearbeiten"
                                                   matTooltipPosition="right"
                                                   matTooltipClass="tooltip-popup"></a>
                                                <a class="fas fa-dog icon"
                                                   matTooltip="Alle tierbezogenen Transaktionen"
                                                   (click)="openDialog(SHOW_ASSOCIATED_ANIMALS_DIALOG, true, element)"
                                                   matTooltipPosition="right"
                                                   matTooltipClass="tooltip-popup"></a>
                                            </div>
                                        </mat-option>
                                        <mat-option *ngIf="ownerSelectSearch.values !== undefined &&
                                        ownerSelectSearch.values.length === 0">
                                            Keine Ergebnisse gefunden.
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-1 pl-0">
                                <a (click)="openDialog(simpleDialogType.SEARCH_PERSON, false)"
                                   class="fas fa-search icon"
                                   style="margin-top: 33px"
                                   matTooltip="Person suchen"
                                   matTooltipPosition="right"
                                   matTooltipClass="tooltip-popup"></a>
                            </div>
                        </div>

                        <ng-container [ngSwitch]="selected">
                            <ng-container *ngSwitchCase="ActionType.FINDLING.key">
                                <app-findling [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"></app-findling>
                            </ng-container>
                            <ng-container *ngSwitchCase="ActionType.VERGABE.key">
                                <app-vergabe [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"></app-vergabe>
                            </ng-container>
                            <ng-container *ngSwitchCase="ActionType.ABGABE.key">
                                <app-abgabe [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"></app-abgabe>
                            </ng-container>
                            <ng-container *ngSwitchCase="ActionType.ABNAHME.key">
                                <app-abnahme [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"></app-abnahme>
                            </ng-container>
                            <ng-container *ngSwitchCase="ActionType.ANNAHME_PENSIONSTIER.key">
                                <app-annahme-pensionstier
                                        [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"></app-annahme-pensionstier>
                            </ng-container>
                            <ng-container *ngSwitchCase="ActionType.RUECKGABE_PENSIONSTIER.key">
                                <app-rueckgabe-pensionstier
                                        [acquisitionGiveAwayForm]="acquisitionGiveAwayForm"
                                        [personSelectSearch]="personSelectSearch"></app-rueckgabe-pensionstier>
                            </ng-container>
                        </ng-container>
                    </form>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Ausgewählte Tiere</h4>
                </div>
                <div class="card-body">
                    <app-animal-list [dataSourceFromAcquisitionGiveAway]="true"
                                     [showEntryCount]="false"
                                     [enableDelete]="false"
                                     [enableEdit]="false"
                                     [enableDuplicate]="true"
                                     [selectedActionType]="acquisitionGiveAwayForm.controls.actionType.value"
                                     [isAcquisition]="isAcquisition"
                                     (selectedAnimals)="animalAddedToTable($event)"
                                     [entryRemovable]="true">
                    </app-animal-list>
                    <div class="row">
                        <div class="col">
                            <button class="float-right mt-4 ml-3"
                                    mat-raised-button color="primary"
                                    [disabled]="addRequestSent && acquisitionGiveAwayForm.valid"
                                    (click)="submit()">
                                <i class="fas fa-exclamation-circle mr-2"
                                   style="color: #b71c1c"
                                   *ngIf="displayErroneousInputs">
                                </i>
                                Speichern und drucken
                            </button>
                            <mat-icon
                                    [hidden]="!(addRequestSent && acquisitionGiveAwayForm.valid)"
                                    class="float-right" style="margin-top: 30px">
                                <mat-spinner color="accent" diameter="20"></mat-spinner>
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-printing [templateType]="PrintingTemplate.AcquisitionAndGiveAway"
              [actionTypes]="fetchedActionTypes"></app-printing>
